import React, { useEffect, useState } from 'react'
import {
  Dropdown,
  Image,
  Tab,
  Nav,
  OverlayTrigger,
  Popover,
  ListGroup,
  Button
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Truncate from "react-truncate";

import _ from "lodash";
import cx from "classnames";
import Tooltip from "components/Tooltip";
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';
import InfiniteScroll from 'components/InfiniteScroll';
import dateformat from "dateformat";

import { deleteMarketoForm, updateMarketoForm } from 'actions/forms/marketo';
import { deleteHubspotForm, updateHubspotForm } from 'actions/forms/hubspot';
import { fetchCreatedForms, invalidateForms, toggleFormManageView } from 'actions/forms/forms';
import { deleteExternalForm, updateExternalForm } from 'actions/forms/external';
import FormPreview from './components/formPreview';
import { useHistory } from "react-router-dom";

import styles from './forms.module.scss'
import { deletePardotForm, updatePardotForm } from 'actions/forms/pardot';
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_FORM_INTEGRATIONS } from 'constants/mixpanelEvents';
import { createMixpanelEvent } from 'actions/mixpanel';
import { getPageViewedEventPayload } from 'services/mixpanelUtil';

export default function FormsView(props) {
  const dispatch = useDispatch();
  const forms = useSelector(state => _.get(state, `forms.items`, null));
  const formLoading = useSelector(state => _.get(state, `forms.loading`, false));
  const activatedIntegrations = useSelector(state => _.get(state, 'integrations.activated.items', []));

  useEffect(() => {
    dispatch(fetchCreatedForms(0, 20, "hubspot"));
    dispatch(invalidateForms());
    props.formManagementView();

    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_FORM_INTEGRATIONS)
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))    
  }, []);

  if (formLoading && forms.length === 0) {
    return (
      <div className={styles.loaderContainer}>
        <label>Just a moon-ute... Scanning for life forms</label>
      </div>
    )
  }

  const renderForms = () => {
    if (formLoading && forms.length == 0) {
      return;
    }

    if (forms && forms.length == 0) {
      return <FormsEmptyMessage integrations={activatedIntegrations} />
    }

    return <FormsListView integrations={activatedIntegrations} />
  }

  return (
    <div className={styles.formsContainer}>
      {renderForms()}
    </div>
  )
}

function FormsEmptyMessage(props) {
  var canCreateHubspotForm = true;
  var canCreateMarketoForm = true;
  var canCreatePardotForm = true;

  props.integrations && (props.integrations || []).map(item => {
    if (item.type == 'hubspot') {
      canCreateHubspotForm = false;
    }

    if (item.type == 'marketo') {
      canCreateMarketoForm = false;
    }

    if (item.type == 'pardot') {
      canCreatePardotForm = false;
    }
  });

  return (
    <div className={styles.emptyMessage}>
      <div className={styles.heading}> No Forms <br />Found in <br /> your Supplies</div>
      <div className={styles.description}>Looks like there are no forms to fetch from . Go ahead and create your first one now!</div>
      <CreateFormToggle
        canCreateHubspotForm={canCreateHubspotForm}
        canCreateMarketoForm={canCreateMarketoForm}
        canCreatePardotForm={canCreatePardotForm}
      />
    </div>
  )
}

function IntegrationNotEnabledEmptyMessage() {
  const history = useHistory();
  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));

  const handleActivateIntegrationClick = () => {
    history.push(`/app/${workspace.id}/integration-settings/integration`);
  }

  return (
    <div className={styles.emptyMessage}>
      <div className={styles.heading}> No Forms <br />to Display Now</div>
      <div className={styles.description}>Integrate Cleverstory with an application of your choice so your favourite forms can show up here!</div>
      <Button className={styles.activateIntegration}
        onClick={handleActivateIntegrationClick}
        size="sm"
        variant="primary">
        Activate Integration
      </Button>
    </div>
  )
}

function CreateFormToggle({ canCreateHubspotForm, canCreateMarketoForm, canCreatePardotForm }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const isFormManageView = useSelector(state => _.get(state, `forms.formManageView`, false));
  const [show, setShow] = useState(false);

  const handleClick = (type) => {
    history.push(`/app/${workspace.id}/integration-settings/forms/new?type=${type}`);
    dispatch(toggleFormManageView(!isFormManageView))
  }

  return (
    <Dropdown
      onMouseLeave={() => setShow(false)}
      onMouseOver={() => setShow(true)}
      className={styles.createFormButton}
      show={show}
      onToggle={(nextShow) => setShow(nextShow)}>

      <Dropdown.Toggle variant="success" id="dropdown-basic">
        <i className={cx(styles.icon, 'cleverstory-plus')} />
        Create a Form
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item className={{ [styles.disabled]: canCreateHubspotForm }} disabled={canCreateHubspotForm} onClick={() => handleClick("hubspot")}>
          <div className={styles.logoContainer}>
            <Image src={"/images/integrations/hubspot.png"} />
          </div> Hubspot</Dropdown.Item>
        <Dropdown.Item className={{ [styles.disabled]: canCreateMarketoForm }} disabled={canCreateMarketoForm} onClick={() => handleClick("marketo")}>
          <div className={styles.logoContainer}>
            <Image src={"/images/integrations/marketo.png"} />
          </div>Marketo</Dropdown.Item>
        <Dropdown.Item className={{ [styles.disabled]: canCreatePardotForm }} disabled={canCreatePardotForm} onClick={() => handleClick("pardot")}>
          <div className={styles.logoContainer}>
            <Image src={"/images/integrations/pardot.png"} />
          </div>Pardot</Dropdown.Item>
        <Dropdown.Item onClick={() => handleClick("external")}>
          <div className={styles.logoContainer}>
            <Image src={"/images/forms/external_form.svg"} />
          </div>External</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

function FormsListView(props) {
  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const history = useHistory();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const handleClick = (type) => {
    history.push(`/app/${workspace.id}/integration-settings/forms?type=${type}`);
  }

  var canCreateHubspotForm = true;
  var canCreateMarketoForm = true;
  var canCreatePardotForm = true;

  var eventKey = null;

  props.integrations && (props.integrations || []).map(item => {
    if (item.type == 'hubspot') {
      canCreateHubspotForm = false;
      eventKey = 'hubspot';
    }

    if (item.type == 'marketo') {
      canCreateMarketoForm = false;
      eventKey = 'marketo';
    }

    if (item.type == 'pardot') {
      canCreatePardotForm = false;
      eventKey = 'pardot';
    }
  });

  if (urlParams.get('type')) {
    eventKey = urlParams.get('type');
  }

  if(!eventKey) {
    eventKey = 'external';
  }

  return (
    <div className={styles.content}>
      <header className={styles.header}>
        <div className={styles.wrapper}>
          <h1>Form Management</h1>
          <span>One space to manage them all</span>
        </div>

        <CreateFormToggle canCreateHubspotForm={canCreateHubspotForm} canCreateMarketoForm={canCreateMarketoForm}  canCreatePardotForm={canCreatePardotForm}/>
      </header>

      <div className={styles.formManagement}>
        <Tab.Container id="form-management-tab" defaultActiveKey={eventKey}>
          <header className={styles.formManagementHeader}>
            <Nav variant="pills" className={styles.formManagementTab}>
              <Nav.Item hidden={canCreateHubspotForm}>
                <Nav.Link eventKey="hubspot" onClick={() => { handleClick("hubspot") }}><div className={styles.logoContainer}>
                  <Image src={"/images/integrations/hubspot.png"} />
                </div>Hubspot</Nav.Link>
              </Nav.Item>
              <Nav.Item hidden={canCreateMarketoForm}>
                <Nav.Link eventKey="marketo" onClick={() => { handleClick("marketo") }}><div className={styles.logoContainer}>
                  <Image src={"/images/integrations/marketo.png"} />
                </div>Marketo</Nav.Link>
              </Nav.Item>
              <Nav.Item hidden={canCreatePardotForm}>
                <Nav.Link eventKey="pardot" onClick={() => { handleClick("pardot") }}><div className={styles.logoContainer}>
                  <Image src={"/images/integrations/pardot.png"} />
                </div>Pardot</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="external" onClick={() => { handleClick("external") }}><div className={styles.logoContainer}>
                  <Image src={"/images/forms/external_form.svg"} />
                </div>External</Nav.Link>
              </Nav.Item>
            </Nav>
            <section
              className={cx(styles.buttonContainer, styles.primaryActions)} >
            </section>
          </header>

          <Tab.Content>
            <Tab.Pane eventKey="hubspot">
              <FormCardView type="hubspot" />
            </Tab.Pane>
            <Tab.Pane eventKey="marketo">
              <FormCardView type="marketo" />
            </Tab.Pane>
            <Tab.Pane eventKey="pardot">
              <FormCardView type="pardot" />
            </Tab.Pane>
            <Tab.Pane eventKey="external">
              <FormCardView type="external" />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
}

function FormCardView(props) {
  const dispatch = useDispatch();
  var forms = useSelector(state => _.get(state, `forms.items`, null));
  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item"));
  const isFormManageView = useSelector(state => _.get(state, `forms.formManageView`, false));
  const loading = useSelector(state => _.get(state, `forms.loading`, false));
  const pagination = useSelector(state => _.get(state, 'forms.pagination', {}));
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;
  const activatedIntegrations = useSelector(state => _.get(state, 'integrations.activated.items', []));

  forms = forms.filter(item => {
    return item.type == props.type;
  });

  let history = useHistory();

  const [state, setState] = useState({
    nameEditable: false,
    selectedForm: null,
    formPreview: false,
    formName: null
  })

  const handleEdit = (form) => {
    history.push(`/app/${workspace.id}/integration-settings/forms/${form.id}?type=${form.type}`);
    dispatch(toggleFormManageView(!isFormManageView))
  }

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    dispatch(fetchCreatedForms(nextPage, 20, "hubspot"));
  }

  const handlePreview = (form) => {
    setState(state => {
      return {
        ...state,
        formPreview: true,
        selectedForm: form
      }
    })
  }

  const handleDelete = (formId) => {
    document.body.click()
    setState(state => {
      return {
        ...state,
        nameEditable: false
      }
    })

    switch (props.type) {
      case "hubspot": {
        dispatch(deleteHubspotForm(props.type, formId));
      }

      case "marketo": {
        dispatch(deleteMarketoForm(props.type, formId));
      }

      case "pardot": {
        dispatch(deletePardotForm(props.type, formId));
      }

      case "external": {
        dispatch(deleteExternalForm(formId));
      }
    }
  }

  const handleClose = () => {
    setState(state => {
      return {
        ...state,
        formPreview: false
      }
    })
  }

  const handleRename = (form) => {
    setState(state => {
      return {
        ...state,
        selectedForm: form,
        formName: form.name,
        nameEditable: true
      }
    })
  }

  const handleUpdateName = (form) => {
    setState(state => {
      return {
        ...state,
        nameEditable: false
      }
    })

    if (form.name == state.formName) {
      return;
    }

    var updateRequest = {
      id: form.id,
      name: state.formName,
      type: props.type
    }

    switch (form.type) {
      case "hubspot": {
        dispatch(updateHubspotForm(updateRequest));
      }

      case "marketo": {
        dispatch(updateMarketoForm(updateRequest));
      }

      case "pardot": {
        dispatch(updatePardotForm(updateRequest))
      }

      case "external": {
        dispatch(updateExternalForm(form.id, updateRequest))
      }
    }
  }

  const handleFormNameChange = (value) => {
    setState(state => {
      return {
        ...state,
        formName: value
      }
    })
  }

  return (
    <InfiniteScroll
      loading={loading}
      hasMore={hasMoreItems}
      loadMore={loadMore}
    >
      <div className={styles.createdFormsContainer}>
        {forms && forms.map(form => {
          return (
            <div className={styles.createdForm} >
              <div className={styles.createdFormImage}>
                <img src="/images/forms/formPreview.svg" alt="" />
              </div>
              <div className={styles.createdFormContent}>
                <div className={styles.name}>
                <RenderName
                  state={state}
                  form={form}
                  onBlur={handleUpdateName}
                  onChange={handleFormNameChange}
                  value={state.formName}
                  type="text"
                />
                </div>

                <div className={styles.info}>
                  <div className={styles.date}>Created on: {dateformat(_.get(form, 'createdDate'), 'dd mmm yyyy')} </div>
                  <div className={styles.date}>Last updated on: {dateformat(_.get(form, 'modifiedDate'), 'dd mmm yyyy')}</div>
                </div>

                <div className={styles.actions}>
                  <Tooltip placement='bottom' content='Preview'>
                    <Button className={styles.actionGroup} variant="info">
                      <i className={cx("cleverstory-view", styles.viewIcon)} onClick={() => handlePreview(form)} />
                    </Button>
                  </Tooltip>

                  <Tooltip placement="bottom" content="Edit">
                    <Button className={styles.actionGroup} variant="info" onClick={() => handleEdit(form)}>
                      <i className={cx("cleverstory-edit")} />
                    </Button>
                  </Tooltip>

                  <OverlayTrigger rootClose={true} trigger={['click']} placement="right"
                    overlay={
                      <Popover className={styles.formCardMoreAction} id="popover-basic">
                        <ListGroup>
                          <ListGroup.Item className={styles.storyboardCardMoreList} onClick={() => handleRename(form)}>Rename</ListGroup.Item>
                          <ListGroup.Item className={styles.storyboardCardMoreList} onClick={() => handleDelete(form.id)}>Delete</ListGroup.Item>
                        </ListGroup>
                      </Popover>
                    }>
                    <Button className={cx(styles.more, styles.action)} variant="info">
                      <i className={cx("cleverstory-more")} />
                    </Button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          )
        })}

        {state.formPreview &&
          <FormPreview preview={state.formPreview} editable={false} form={state.selectedForm} onClose={handleClose} onFormSubmit={() => { }} onOtpFormSubmit={() => { }} onOtpResend={() => { }}/>
        }
      </div>
      {forms && forms.length == 0 &&
        <FormsEmptyMessage integrations={activatedIntegrations} />
      }
    </InfiniteScroll>
  )
}

function RenderName({ state, form, onBlur, onChange, value, type }) {

  return (
    <>
      {state.nameEditable && (form.id === state.selectedForm.id) ? (
        <input
          onBlur={() => onBlur(form)}
          value={value}
          autoFocus
          onChange={(e) => onChange(e.target.value)}
          type={type}
          className={styles.nameInput}
        />
      ) : (
        <TruncatedTextWithTooltip placement="top" content={form.name}>
          {value != null && (form.id === state.selectedForm.id) ? value : form.name}
        </TruncatedTextWithTooltip>
      )}
    </>
  )
}